import { BlockResponse } from "@/Contracts/ProposalBuilder/Block";
import { ImportProductsToQuoteResponse } from "@/Contracts/ProposalBuilder/ImportProducts";

export enum EFileType {
	PDF = "pdf",
	XLS = "xls"
}

export interface IZImportProductsToQuoteDrawerProps {
	visible: boolean;
	onClose: () => void;
	blockId: string;
	onImportConfirmed: (
		updatedBlock?: BlockResponse,
		sectionName?: string
	) => Promise<unknown> | void;
	importProductsToQuote: (
		blockId: string,
		file: File,
		lineItemDiscount: string,
		targetMargin: string,
		userPreferences: string,
		additionalImages: File[],
		markup?: string
	) => Promise<ImportProductsToQuoteResponse>;
}
